import React from 'react';
import { CTAButton } from './CTAButton';
import { BoxImage } from './BoxImage';
export function FinalCTA() {
  return <section className="bg-navy px-3 py-4 text-center sm:px-6" data-id="element-49" data-mp="3udf8az5tp7i7">
      <div className="mx-auto max-w-xl" data-id="element-50" data-mp="c6ivdvtic587">
        <h2 className="text-[1.1rem] font-extrabold uppercase leading-tight text-white sm:text-[1.7rem]" data-id="element-51" data-mp="c7k8e5u331sk">
          One last question
        </h2>
        <p className="mt-1 text-[0.78rem] leading-[1.4] text-white/85 sm:text-[0.92rem]" data-id="element-52" data-mp="m4ykxucvz6fl">
          When another ECG, arrhythmia or cardiac finding appears... Do you immediately know what
          you're looking at and where to start? Stop jumping between scattered resources and trying
          to understand cardiology from text alone. Interpret the ECG. Compare the patterns. Follow
          the visual references.
        </p>
        <p className="mt-1 font-heading text-[0.72rem] font-extrabold uppercase tracking-wide text-teal-light sm:text-[0.86rem]" data-id="element-53" data-mp="14whnk0300ih3">
          Interpret. Compare. Recognize.
        </p>

        <BoxImage className="mx-auto mt-2 max-w-[230px] sm:max-w-[290px]" data-id="element-54" data-mp="2c56dc9woafm1" />

        <p className="mt-2 font-heading text-[1rem] font-extrabold uppercase text-white sm:text-[1.4rem]" data-id="element-55" data-mp="2h3rgah3b7de6">
          ❤️ CARDIOLOGY VISUAL ATLAS™
        </p>
        <p className="mt-0.5 text-[0.66rem] font-bold uppercase tracking-wide text-white/80 sm:text-[0.8rem]" data-id="element-56" data-mp="2m19fhfriye8z">
          The Complete Visual Study System for Cardiology Students
        </p>
        <p className="mt-0.5 text-[0.6rem] font-bold uppercase tracking-[0.12em] text-teal-light sm:text-[0.74rem]" data-id="element-57" data-mp="2v2r3rlf35m8r">
          Understand • Interpret • Compare • Identify • Connect • Recognize
        </p>

        <div className="mx-auto mt-2 max-w-md" data-id="element-58" data-mp="34un658o7fyis">
          <p className="font-heading text-[0.76rem] font-extrabold uppercase tracking-wide text-white sm:text-[0.9rem]" data-id="element-59" data-mp="39sf34h3piatu">
            🔥 GET THE COMPLETE SYSTEM TODAY
          </p>
          <div className="mt-1.5" data-id="element-60" data-mp="3epos5vn6okh5">
            <CTAButton label="⚡ GET CARDIOLOGY VISUAL ATLAS™" data-id="element-61" data-mp="3islgm2zenat0" />
          </div>
          <p className="mt-1.5 text-[0.62rem] font-bold uppercase tracking-wide text-white/75 sm:text-xs" data-id="element-62" data-mp="1joczyjhcj9z6">
            Immediate Access • Digital Delivery 🛡️ 7-Day Money-Back Guarantee
          </p>
        </div>
      </div>
    </section>;
}